@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container mb-5 p-3">
        <div class="w-fit">
            <app-back-button routerLink="/policies" component="Policies"></app-back-button>
        </div>
        <div class="d-flex align-items-center mt-3">
            <div class="col-lg-12 col-12">
                <h1>Insurance Policy Entry</h1>
            </div>
        </div>
        <div class="row mt-4 mb-5">
            <form [formGroup]="policyInfoForm">
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Policy Name<span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="Enter Policy Name" formControlName="name">
                            <mat-error *ngIf="policyInfoForm.controls['name'].errors?.['invalidPolicyName']">* Policy Name is already in use</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Currency<span class="required-input">*</span></mat-label>
                            <mat-select formControlName="currency_id">
                                <mat-option *ngFor="let currency of currencies" [value]="currency.id.toString()">
                                    {{ currency.display_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-label>Available For All Countries</mat-label>
                        <mat-radio-group formControlName="all_countries">
                            <mat-radio-button [value]="'1'">
                                Yes
                            </mat-radio-button>
                            <mat-radio-button [value]="'0'" class="radio-button-margin-left">
                                No
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Contents Coverage ({{ this.userContextProvider.currencyCode }})</mat-label>
                            <input type="number" matInput placeholder="Contents Coverage" formControlName="damage_coverage" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Liability Coverage ({{ this.userContextProvider.currencyCode }})</mat-label>
                            <input type="number" matInput placeholder="Liability Coverage" formControlName="liability_coverage" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Dwelling Coverage ({{ this.userContextProvider.currencyCode }})</mat-label>
                            <input type="number" matInput placeholder="Dwelling Coverage" formControlName="dwelling_coverage" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Average Nightly Rate Minimum ({{ this.userContextProvider.currencyCode }})</mat-label>
                            <input type="number" matInput placeholder="Nightly Rate Min" formControlName="range_reservation_price_from" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Average Nightly Rate Maximum ({{ this.userContextProvider.currencyCode }})</mat-label>
                            <input type="number" matInput placeholder="Nightly Rate Max" formControlName="range_reservation_price_to" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column"></div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Number of Guests Minimum</mat-label>
                            <input type="number" matInput placeholder="Guests Min" formControlName="range_guests_from">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Number of Guests Maximum</mat-label>
                            <input type="number" matInput placeholder="Guests Max" formControlName="range_guests_to">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column"></div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Number of Bedrooms Minimum</mat-label>
                            <input type="number" matInput placeholder="Bedrooms Min" formControlName="range_no_of_bedrooms_from">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Number of Bedrooms Maximum</mat-label>
                            <input type="number" matInput placeholder="Bedrooms Max" formControlName="range_no_of_bedrooms_to">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column"></div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <textarea matInput placeholder="Description" formControlName="description"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <textarea matInput placeholder="Note" formControlName="note"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column"></div>
                </div>
            </form>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-end">
            <button mat-raised-button class="finish-button" routerLink="/policies">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button submit-policy-button"
                [disabled]="!canCreatePolicyInfo()" (click)="submitPolicyInfo()">
                <mat-icon>check</mat-icon>
                Submit Policy
            </button>
        </div>
        <hr>
        <div *ngIf="!canCreatePolicyInfo()" class="mt-4">
            <mat-action-row class="mt-4 d-flex justify-content-end">
                <div class="d-flex justify-content-end align-items-center text-muted">
                    <span class="required-input">*</span>&nbsp;- Required fields before submitting policy info.
                </div>
            </mat-action-row>
        </div>
    </div>
}